export default (data) => {
  const arr = data.expr || data;
  const exportData = {
    detail: data.detail,
  };
  const diffKeys = ['useTimes', 'launchDays', 'startTimes', 'lostDays'];

  function eachData(keyArr, relation, parentRel) {
    // 判断传递的数据类型
    const each = keyArr instanceof Array ? keyArr : Object.keys(keyArr);
    each.forEach((x) => {
      // 判断值是否为字符串
      let key = typeof x === 'string' ? x : Object.keys(x)[0];
      const v = typeof x === 'string' ? keyArr[x] : x[key];
      const val = typeof x === 'string' ? { [x]: keyArr[x] } : x;
      // 当前 x的值如果为数组递归
      if (v instanceof Array) {
        eachData(v, key, relation);
        return;
      }
      const diffKey = Object.keys(v).filter(diff => diffKeys.indexOf(diff) > -1);
      if (diffKey.length > 0) key = diffKey[0];
      // exportData存在当前键名并且 relation类型全等 expr push当前 val
      if (exportData[key] && exportData[key].relation === relation) {
        exportData[key].expr.push(val);
      } else {
        // 创建空键值并赋值
        exportData[key] = {
          relation: '',
          expr: [],
          parentRel,
        };
        exportData[key].relation = relation || '$and';
        exportData[key].expr.push(val);
      }
    });
  }

  eachData(arr);

  return exportData;
};
